import { Injectable } from '@angular/core';
import { CurrentPortfolio } from '../models/current-portfolio.model';
import { Subject } from 'rxjs';
import { InvestableParameters } from '../models/investable-parameters.model';
import { Cluster } from '../models/cluster.model';
import { ApiRequestsService } from './api-requests.service';
import { ListsService } from './lists.service';

@Injectable({
  providedIn: 'root'
})
export class InvestableService {

  customInvestable: CurrentPortfolio;
  customInvestableSubject = new Subject<CurrentPortfolio>();

  investableParameters: InvestableParameters;
  investableParametersSubject = new Subject<InvestableParameters>();

  constructor(private apiRequestsService: ApiRequestsService,
              private listsService: ListsService) {
    this.investableParameters = new InvestableParameters();
  }

  emitCustomInvestable() {
    // notify subscriptions and provide them with custom investable
    console.log('CALL InvestableService.emitCustomInvestable()');
    this.customInvestableSubject.next(this.customInvestable);
  }

  emitInvestableParameters() {
    // notify subscriptions and provide them with investable parameters
    console.log('CALL InvestableService.emitInvestableParameters()');
    this.investableParametersSubject.next(this.investableParameters);
  }

  async computeCustomInvestable(parameters: InvestableParameters, cluster: Cluster, do_save: boolean = false) {
    const cluster_id: number = cluster ? cluster.id : undefined;

    const data: any = await this.apiRequestsService.post('custom-investable',{
      cluster_id: cluster_id,
      parameters: parameters,
      do_save: do_save
    });

    if (data.status=='OK') {
      await this.listsService.cleanData(data.data);

      let investable = new CurrentPortfolio(cluster_id);
      investable.initFromData(data.data);
      this.customInvestable = investable;
      this.emitCustomInvestable();
    }
  }

  resetInvestableParameters() {
    this.investableParameters = new InvestableParameters();
    this.emitInvestableParameters();
  }

}
